/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button, Dialog,
} from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import Actions from '../../actions';
import Loading from '../Loading';
import Form from './Form';

const StyledTableCell = withStyles((theme) => {
  return {
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  };
})(TableCell);

const StyledTableRow = withStyles((theme) => {
  return {
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  };
})(TableRow);

const useStyles = makeStyles((theme) => {
  return {
    table: {
      margin: 'auto',
      marginTop: 20,
      marginBottom: 20,
      // width: '40%',
      [theme.breakpoints.up('sm')]: {
        width: '95%',
      },
    },
  };
});

function CustomizedTables(props) {
  const { data, loading, getOffers } = props;
  const classes = useStyles();
  const [list, setList] = useState(null);
  const [spinner] = useState(false);
  const [state, setState] = useState(null);
  const [open, setOpen] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    type: 'success',
    text: '',
  });
  const closeSnack = () => { return setSnack({ ...snack, open: false }); };
  const closeDialog = () => {
    // console.log('closing dialog');
    setOpen(false);
  };
  const handleEdit = (item) => {
    if (item) setState(item);
    setOpen(true);
  };

  useEffect(() => {
    if (!data && !list) getOffers();
    if (data) setList(data.data);
  }, [data, getOffers, list]);

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Dialog open={open} onClose={closeDialog}>
        { open && <Form items={state} closeDialog={closeDialog} />}
      </Dialog>
      <Loading
        loading={spinner || loading}
        onClose={closeSnack}
        snack={snack}
      />
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Name</StyledTableCell>
            <StyledTableCell align="right">Type</StyledTableCell>
            <StyledTableCell align="right">Currency</StyledTableCell>
            <StyledTableCell align="right">personalTherapyRegionId</StyledTableCell>
            <StyledTableCell align="right">realPrice</StyledTableCell>
            <StyledTableCell align="right">discountedPrice</StyledTableCell>
            <StyledTableCell align="right">discountedPriceInUSD</StyledTableCell>
            <StyledTableCell align="right">appAccessMonths</StyledTableCell>
            <StyledTableCell align="right">recurringNumber</StyledTableCell>
            <StyledTableCell align="right">recurringSessions</StyledTableCell>
            <StyledTableCell align="right">recurringSessionsFrequencyDays</StyledTableCell>
            <StyledTableCell align="right">userUid</StyledTableCell>
            <StyledTableCell align="right">specials</StyledTableCell>
            <StyledTableCell align="right">isPopular</StyledTableCell>
            <StyledTableCell align="right">isInitial</StyledTableCell>
            <StyledTableCell align="right">recurringSessionsFrequency</StyledTableCell>
            <StyledTableCell align="right">Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading && list && list.map((item, i) => {
            return (
              <StyledTableRow key={i}>
                <StyledTableCell align="left">{item.name}</StyledTableCell>
                <StyledTableCell align="right">{item.type}</StyledTableCell>
                <StyledTableCell align="right">{item.currency}</StyledTableCell>
                <StyledTableCell align="right">{item.personalTherapyRegionId}</StyledTableCell>
                <StyledTableCell align="right">{item.realPrice}</StyledTableCell>
                <StyledTableCell align="right">{item.discountedPrice}</StyledTableCell>
                <StyledTableCell align="right">{item.discountedPriceInUSD}</StyledTableCell>
                <StyledTableCell align="right">{item.appAccessMonths}</StyledTableCell>
                <StyledTableCell align="right">{item.recurringNumber}</StyledTableCell>
                <StyledTableCell align="right">{item.recurringSessions}</StyledTableCell>
                <StyledTableCell align="right">{item.recurringSessionsFrequencyDays}</StyledTableCell>
                <StyledTableCell align="right">{item.uid}</StyledTableCell>
                <StyledTableCell align="right">
                  {
                  item.specials && item.specials.map((ite) => { return (`${ite}, `); })
                }
                </StyledTableCell>
                <StyledTableCell align="right">{item.isPopular ? 'True' : 'False'}</StyledTableCell>
                <StyledTableCell align="right">{item.isInitial ? 'True' : 'False'}</StyledTableCell>
                <StyledTableCell align="right">{item.recurringSessionsFrequency}</StyledTableCell>
                <StyledTableCell align="right">
                  <Button
                    onClick={() => { return handleEdit(item); }}
                    startIcon={<Edit />}
                    variant="outlined"
                    color="primary"
                  >
                    Edit
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    data: state.offers.data,
    loading: state.offers.fetching,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomizedTables);
